import React from 'react';

import { Grid, Typography } from '@mui/material';
import { SelectInput } from 'react-admin';
import booleanChoices from '../../../constants/booleanChoices';
import { pepRoleChoices } from '../../../constants/pepRoles';
import { pepRelationChoices } from '../../../constants/pepRelations';
import { countryChoices } from '../../../constants/countries';
import SmartDateInput from '../../../customFields/SmartDateInput';
import CommentInput from '../../comment/CommentInput';

const Pep = () => (
  <Grid container spacing={10}>
    <Grid size={12}>
      <Typography
        color="#646464"
        variant="h6"
      >
        Politically exposed person (PEP)
      </Typography>
    </Grid>
    <Grid
      size={{
        xs: 12,
        md: 10,
      }}
    >
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
            md: 4,
          }}
        >
          <SelectInput source="value.isPep" fullWidth choices={booleanChoices.en} label="Is the person or someone close to them politically exposed?" />
        </Grid>

        <Grid
          size={{
            xs: 12,
            md: 4,
          }}
        >
          <SelectInput fullWidth source="value.pep.role" choices={pepRoleChoices('en')} label="Role" />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 4,
          }}
        >
          <SelectInput fullWidth source="value.pep.relation" choices={pepRelationChoices('en')} />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 4,
          }}
        >
          <SelectInput fullWidth source="value.pep.country" choices={countryChoices('en')} />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 4,
          }}
        >
          <SmartDateInput fullWidth source="value.pep.startDate" />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 4,
          }}
        >
          <SmartDateInput fullWidth source="value.pep.endDate" />
        </Grid>
      </Grid>
    </Grid>
    <Grid
      size={{
        xs: 12,
        md: 10,
      }}
    >
      <CommentInput
        source="comment"
        helperText={false}
        placeholder="Please explain your decision."
      />
    </Grid>
  </Grid>
);

export default Pep;
